const COMPANYRECORDSTATE = {
	DRAFT: 1,
	UNCOMPLETE: 2,
	PENDING: 3,
	VALID: 4,
}
export default COMPANYRECORDSTATE
